import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PaketiClient, SubscriptionPackage } from '@kodit/core/data-api';
import { AuthService } from '@kodit/core/services';

@Component({
  selector: 'kodit-placanja-page',
  templateUrl: './placanja-page.component.html',
  styleUrls: ['./placanja-page.component.scss']
})
export class PlacanjaPageComponent implements OnInit, OnDestroy {
  /** Subs */
  private _subs: Subscription = new Subscription();

  /** Props */
  subExpired = false;
  packages: {
    name: string,
    price: number,
    icon: string,
    priceLabel: string,
    isAddition: boolean
  }[] | undefined;
  expires: string;
  isTrial: boolean;
  subDaysLeft: number;

  constructor(
    private _client: PaketiClient,
    private _route: ActivatedRoute,
    private _authService: AuthService,
    private _router: Router,
  ) {
    this.subExpired = this._route.snapshot.data.subExpired;
    this.isTrial = this._authService.getIsTrial;
    this.subDaysLeft = this._authService.getSubDaysLeft;
    this.expires = this._authService.getSubExpires;

    if(!this.subExpired) {
      this._subs.add(
        this._client.getUserPackages()
          .subscribe(res => {
            this.packages = res.data.paketi.packages.map(p => ({
              name: p.label ?? '',
              price: p.price ?? 0,
              icon: this.getIconBySubType(p.packageType),
              priceLabel: p.priceLabel ?? '',
              isAddition: p.isAddition,
            }));
          })
      );
    }
  }

  ngOnInit(): void {
  }

  getMainPackages() {
    return this.packages.filter(p => !p.isAddition);
  }

  getAdditionalPackages() {
    return this.packages.filter(p => p.isAddition);
  }

  getPriceUnit(priceLabel: string) {
    return priceLabel.split('/')[0];
  }

  getPriceUnitPeriod(priceLabel: string) {
    return priceLabel.split('/')[1];
  }

  getIconBySubType(type: SubscriptionPackage) {
    switch (type) {
      case SubscriptionPackage.MALOPRODAJA:
        return 'cart.svg';
      case SubscriptionPackage.VELEPRODAJA:
      case SubscriptionPackage.PROIZVODNJA:
        return 'box.svg';
      case SubscriptionPackage.FISKALNA_KASA:
        return 'bill.svg';
      case SubscriptionPackage.EFAKTURE:
        return 'document.svg';
      case SubscriptionPackage.EOTPREMNICE:
        return 'box.svg';
      case SubscriptionPackage.EFAKTURE_API:
      case SubscriptionPackage.EOTPREMNICE_API:
      case SubscriptionPackage.FISKLANI_API:
        return 'cpu.svg';
      case SubscriptionPackage.KORISNICKI_NALOG:
        return 'user-id.svg';
      default:
        return 'cart.svg';
    }
  }

  goToPaketi() {
      this._router.navigate(['pretplata', 'paketi']).then();
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }
}
